import React from 'react';
import { Calendar, Clock, MapPin, User, UserCheck } from 'lucide-react';
import { motion } from 'framer-motion';

const plans = [
  { scheme: '線上組', price: 'NT$3,600', slots: '不限', note: '含線上教材', icon: User },
  { scheme: '實體組', price: 'NT$9,500', slots: '80 名（基礎班 40 名＋進階班 40 名，含 20 位女性保障名額）', note: '含三餐、營服，不含住宿', icon: UserCheck },
];

const timeline = [
  { event: '報名截止', date: '5/31 (日) 23:59:59' },
  { event: '營期', date: '7/13 (一) ~ 7/18 (六)' },
];

const Registration = () => {
  return (
    <section id="registration" className="py-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-[#e6f0fa]/90 to-[#ffffff]/90 backdrop-blur-sm">
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="max-w-7xl mx-auto px-2 sm:px-4"
      >
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold bg-gradient-to-r from-[#60a5fa] to-[#93c5fd] bg-clip-text text-transparent">
            報名資訊
          </h2>
          <p className="mt-4 text-base sm:text-lg md:text-xl text-[#475569] font-light">
            了解報名詳情，選擇最適合您的參與方式
          </p>
        </div>

        <div className="max-w-4xl mx-auto mb-10">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            <div className="flex items-center p-4 bg-[rgba(96,165,250,0.1)] rounded-lg border border-[#e0e7ff]/50">
              <Calendar className="w-10 h-10 text-[#60a5fa] mr-4" />
              <div>
                <h3 className="text-xl font-semibold text-[#475569]">營隊日期</h3>
                <p className="text-[#475569]">2026/07/13（一）～ 2026/07/18（六）</p>
              </div>
            </div>
            <div className="flex items-center p-4 bg-[rgba(96,165,250,0.1)] rounded-lg border border-[#e0e7ff]/50">
              <Clock className="w-10 h-10 text-[#60a5fa] mr-4" />
              <div>
                <h3 className="text-xl font-semibold text-[#475569]">報名截止</h3>
                <p className="text-[#475569]">2026/05/31（日）23:59:59 止</p>
              </div>
            </div>
            <div className="flex items-center p-4 bg-[rgba(96,165,250,0.1)] rounded-lg border border-[#e0e7ff]/50">
              <MapPin className="w-10 h-10 text-[#60a5fa] mr-4" />
              <div>
                <h3 className="text-xl font-semibold text-[#475569]">營隊地點</h3>
                <p className="text-[#475569]">國立陽明交通大學 光復校區（實體）、線上同步舉行</p>
              </div>
            </div>
          </div>
        </div>

        <div className="max-w-4xl mx-auto mb-10">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {plans.map((plan, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: idx * 0.2 }}
                className="p-4 bg-[rgba(96,165,250,0.1)] rounded-lg border border-[#e0e7ff]/50"
              >
                <div className="flex items-center mb-2">
                  <plan.icon className="w-8 h-8 text-[#60a5fa] mr-2" />
                  <h3 className="text-lg font-semibold text-[#475569]">{plan.scheme}</h3>
                </div>
                <p className="text-2xl font-bold bg-gradient-to-r from-[#60a5fa] to-[#93c5fd] bg-clip-text text-transparent">{plan.price}/人</p>
                <p className="text-[#475569] mt-1">{plan.note}</p>
                <p className="text-[#475569] text-sm mt-1">名額：{plan.slots}</p>
              </motion.div>
            ))}
          </div>
          <div className="flex flex-col items-center mt-8 gap-4">
            <a
              href="https://forms.gle/SDBmnjfWRQxcmCSR7"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[rgba(96,165,250,0.9)] text-white px-6 py-3 rounded-full font-semibold hover:bg-[rgba(96,165,250,1)] transition-colors"
            >
              立即報名
            </a>
            <div className="flex items-start gap-2 max-w-xl px-4 py-3 bg-[rgba(96,165,250,0.12)] border border-[#93c5fd]/60 rounded-lg text-sm text-[#1e293b]">
              <Clock className="w-5 h-5 text-[#60a5fa] shrink-0 mt-0.5" />
              <p>
                本次報名採用<span className="font-semibold text-[#1e3a8a]">隨報隨審制</span>，報名後請注意電子信箱，預計一週內回覆是否錄取。
              </p>
            </div>
          </div>
        </div>

        <div className="max-w-4xl mx-auto mb-10">
          <h3 className="text-2xl font-semibold bg-gradient-to-r from-[#60a5fa] to-[#93c5fd] bg-clip-text text-transparent mb-4 text-center">報名時間表</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {timeline.map((item, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: idx * 0.1 }}
                className="relative p-4 bg-[rgba(96,165,250,0.1)] rounded-lg border border-[#e0e7ff]/50"
              >
                <div className="flex items-center">
                  <Calendar className="w-6 h-6 text-[#60a5fa] mr-3" />
                  <div>
                    <p className="text-[#475569] font-semibold">{item.event}</p>
                    <p className="text-[#475569] text-sm">{item.date}</p>
                  </div>
                </div>
                {idx < timeline.length - 1 && (
                  <div className="absolute top-0 left-7 w-0.5 h-full bg-[#e0e7ff]/30 -z-10" />
                )}
              </motion.div>
            ))}
          </div>
        </div>

        <div className="max-w-4xl mx-auto mb-10">
          <h3 className="text-2xl font-semibold bg-gradient-to-r from-[#60a5fa] to-[#93c5fd] bg-clip-text text-transparent mb-4">費用說明表</h3>
          <div className="bg-[rgba(96,165,250,0.1)] rounded-lg border border-[#e0e7ff]/50 overflow-hidden">
            <table className="w-full border-collapse text-sm">
              <thead>
                <tr className="bg-[rgba(96,165,250,0.2)] text-[#475569]">
                  <th className="p-2 border border-[#e0e7ff]/50 font-bold text-left">名稱</th>
                  <th className="p-2 border border-[#e0e7ff]/50 font-bold text-left">定價</th>
                  <th className="p-2 border border-[#e0e7ff]/50 font-bold text-left">單位</th>
                  <th className="p-2 border border-[#e0e7ff]/50 font-bold text-left">備註</th>
                </tr>
              </thead>
              <tbody>
                <tr className="hover:bg-[rgba(96,165,250,0.15)] transition-colors">
                  <td className="p-2 border border-[#e0e7ff]/50 text-[#475569]">基本費用（線上組）</td>
                  <td className="p-2 border border-[#e0e7ff]/50 text-[#475569]">NT$3,600</td>
                  <td className="p-2 border border-[#e0e7ff]/50 text-[#475569]">每人</td>
                  <td className="p-2 border border-[#e0e7ff]/50 text-[#475569]">含線上教材</td>
                </tr>
                <tr className="hover:bg-[rgba(96,165,250,0.15)] transition-colors">
                  <td className="p-2 border border-[#e0e7ff]/50 text-[#475569]">基本費用（實體組）</td>
                  <td className="p-2 border border-[#e0e7ff]/50 text-[#475569]">NT$9,500</td>
                  <td className="p-2 border border-[#e0e7ff]/50 text-[#475569]">每人</td>
                  <td className="p-2 border border-[#e0e7ff]/50 text-[#475569]">含三餐、營服，不含住宿</td>
                </tr>
                <tr className="hover:bg-[rgba(96,165,250,0.15)] transition-colors">
                  <td className="p-2 border border-[#e0e7ff]/50 text-[#475569]">加購營隊五個晚上住宿</td>
                  <td className="p-2 border border-[#e0e7ff]/50 text-[#475569]">NT$1,500</td>
                  <td className="p-2 border border-[#e0e7ff]/50 text-[#475569]">每人</td>
                  <td className="p-2 border border-[#e0e7ff]/50 text-[#475569]">營期間五晚住宿</td>
                </tr>
                <tr className="hover:bg-[rgba(96,165,250,0.15)] transition-colors">
                  <td className="p-2 border border-[#e0e7ff]/50 text-[#475569]">加購營隊前一日住宿</td>
                  <td className="p-2 border border-[#e0e7ff]/50 text-[#475569]">NT$300</td>
                  <td className="p-2 border border-[#e0e7ff]/50 text-[#475569]">每人</td>
                  <td className="p-2 border border-[#e0e7ff]/50 text-[#475569]">需至少加購「營隊五個晚上住宿」才可選</td>
                </tr>
                <tr className="hover:bg-[rgba(96,165,250,0.15)] transition-colors">
                  <td className="p-2 border border-[#e0e7ff]/50 text-[#475569]">加購營隊後一日住宿</td>
                  <td className="p-2 border border-[#e0e7ff]/50 text-[#475569]">NT$300</td>
                  <td className="p-2 border border-[#e0e7ff]/50 text-[#475569]">每人</td>
                  <td className="p-2 border border-[#e0e7ff]/50 text-[#475569]">需至少加購「營隊五個晚上住宿」才可選</td>
                </tr>
                <tr className="hover:bg-[rgba(96,165,250,0.15)] transition-colors">
                  <td className="p-2 border border-[#e0e7ff]/50 text-[#475569]">加購實體講義（基礎班）</td>
                  <td className="p-2 border border-[#e0e7ff]/50 text-[#475569]">NT$500</td>
                  <td className="p-2 border border-[#e0e7ff]/50 text-[#475569]">每人</td>
                  <td className="p-2 border border-[#e0e7ff]/50 text-[#475569]">本次營隊提供加購實體講義，用於輔助學習與重點整理（無提供電子版）；基礎班與進階班版本可分開購買，亦可同時加購</td>
                </tr>
                <tr className="hover:bg-[rgba(96,165,250,0.15)] transition-colors">
                  <td className="p-2 border border-[#e0e7ff]/50 text-[#475569]">加購實體講義（進階班）</td>
                  <td className="p-2 border border-[#e0e7ff]/50 text-[#475569]">NT$500</td>
                  <td className="p-2 border border-[#e0e7ff]/50 text-[#475569]">每人</td>
                  <td className="p-2 border border-[#e0e7ff]/50 text-[#475569]">本次營隊提供加購實體講義，用於輔助學習與重點整理（無提供電子版）；基礎班與進階班版本可分開購買，亦可同時加購</td>
                </tr>
                <tr className="hover:bg-[rgba(96,165,250,0.15)] transition-colors">
                  <td className="p-2 border border-[#e0e7ff]/50 text-[#475569]">舊生推薦</td>
                  <td className="p-2 border border-[#e0e7ff]/50 text-[#475569]">-NT$1,000</td>
                  <td className="p-2 border border-[#e0e7ff]/50 text-[#475569]">每人</td>
                  <td className="p-2 border border-[#e0e7ff]/50 text-[#475569]">不可與其他優惠疊加</td>
                </tr>
                <tr className="hover:bg-[rgba(96,165,250,0.15)] transition-colors">
                  <td className="p-2 border border-[#e0e7ff]/50 text-[#475569]">工人推薦</td>
                  <td className="p-2 border border-[#e0e7ff]/50 text-[#475569]">-NT$1,000</td>
                  <td className="p-2 border border-[#e0e7ff]/50 text-[#475569]">每人</td>
                  <td className="p-2 border border-[#e0e7ff]/50 text-[#475569]">可與團報優惠疊加，但不可與舊生推薦並用</td>
                </tr>
                <tr className="hover:bg-[rgba(96,165,250,0.15)] transition-colors">
                  <td className="p-2 border border-[#e0e7ff]/50 text-[#475569]">團報優惠</td>
                  <td className="p-2 border border-[#e0e7ff]/50 text-[#475569]">-NT$1,000</td>
                  <td className="p-2 border border-[#e0e7ff]/50 text-[#475569]">每人</td>
                  <td className="p-2 border border-[#e0e7ff]/50 text-[#475569]">三人以上適用（包含自己），可與工人推薦疊加，但不可與舊生推薦並用</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="max-w-4xl mx-auto mb-10">
          <h3 className="text-2xl font-semibold bg-gradient-to-r from-[#60a5fa] to-[#93c5fd] bg-clip-text text-transparent mb-4">注意事項</h3>
          <ol className="text-[#475569] list-decimal pl-6 mb-6">
            <li>對象：對程式設計感興趣或準備 APCS 檢定的學生，年齡不拘。</li>
            <li>教學語言：C++。</li>
            <li>實體組名額有限（基礎班 40 名＋進階班 40 名），含 20 位女性保障名額，依報名先後順序排序。</li>
            <li>實體參與因床位有限，正備取名單將依據報名先後順序排序。</li>
            <li>主辦單位活動內容與課程設計，保留隨時修正、暫停、終止或解釋本活動之最終權利。</li>
          </ol>
        </div>

        <div className="max-w-4xl mx-auto">
          <h3 className="text-2xl font-semibold bg-gradient-to-r from-[#60a5fa] to-[#93c5fd] bg-clip-text text-transparent mb-4">聯繫資訊</h3>
          <ul className="text-[#475569] list-disc pl-6">
            <li>活動總召：鍾秉均 / 0905816519 / programchung@gmail.com（課程相關資訊、財務）</li>
            <li>活動行政：李日森 / 0988543898 / rihsen.la13@nycu.edu.tw（行政庶務相關資訊）</li>
            <li>Instagram：<a href="https://www.instagram.com/apcss.camp/" target="_blank" rel="noopener noreferrer" className="text-[#3b82f6] hover:underline">@apcss.camp</a></li>
            <li>Facebook 臉書：<a href="https://www.facebook.com/profile.php?id=61585334401042" target="_blank" rel="noopener noreferrer" className="text-[#3b82f6] hover:underline">APCSS Camp</a></li>
          </ul>
        </div>
      </motion.div>
    </section>
  );
};

export default Registration;